module.exports = __webpack_public_path__ + "static/media/suspend.a0ac2ae4.svg";